// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"Input_inputLabel__JyAJo","inputField":"Input_inputField__1TAKJ"};